"use client";

export function SkipToContent() {
  return (
    <a
      href="#main-content"
      data-faro-user-action-name="skip-to-content"
      className="absolute -top-full left-4 z-[9999] rounded-md bg-background px-6 py-3 text-foreground shadow-lg border outline-none focus-visible:top-4 focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-2 focus-visible:outline-transparent transition-[top]"
      onClick={(e) => {
        e.preventDefault();
        const main = document.getElementById("main-content");
        if (main) {
          main.focus();
        }
      }}
    >
      Skip to main content
    </a>
  );
}
